/** Old configurator/registration pages keep their runtime; ordinary storefront pages skip it. */
export function loadLegacyVue(doc, assets) {
    if (!doc.querySelector('.js-vue-root') || !assets?.script || !assets?.style || doc.querySelector('[data-ovalia-vue]')) return;
    const style = doc.createElement('link');
    style.rel = 'stylesheet';
    style.href = assets.style;
    const script = doc.createElement('script');
    script.src = assets.script;
    script.dataset.ovaliaVue = '';
    doc.head.append(style);
    doc.body.append(script);
}
